<template>
	<div class="p-grid">
		<div class="p-col-12 p-pt-2 p-pb-1">
      <div class="p-grid p-nogutter" style="min-height: 75px;">
        <div class="p-col">
          <div class="p-grid p-ai-center vertical-container">
              <div class="p-col-fixed" style="width:55px;">
                  <a @click="$functions.historyBack()" style="cursor: pointer">
                    <img class="" src="assets/irinox/icons/arrow_back.svg" :alt="$t('common.arrow_left')"/>
                  </a>
              </div>
              <div class="p-col">
                  <h3>{{appliance.name ?? $functions.fixModelName(appliance.modelNumber)}}</h3>
              </div>
          </div>
        </div>
        <div v-if="!readOnlyMode" class="p-col-fixed p-pb-4" style="width: fit-content">
          <Button v-if="(efCycleRunning)" :label="$t('library.cycle.stop_button')" @click="() => {dialog.stop = true;}"  />
        </div>
      </div>
        
        <div v-if="efCycleRunning" class="irinox-form cycle-controls" style="overflow-x: hidden; margin: 0 -2rem;">

          <div class="fade-left"/>
          <div class="fade-right"/>

          <vueper-slides ref="phases" class="no-shadow ex--center-mode" 
              arrows-outside :bullets="false" 
              transition-speed="250" :infinite="false"
              :slideRatio="1/1"
              :disableArrowsOnEdges="true"
              @slide="changeSlide('slide', $event)"
              @ready="carouselReady"
              >      

            <template #arrow-left>
              <img src="assets/irinox/icons/carousel_left.svg"  :alt="$t('common.previous')" />
            </template>

            <template #arrow-right>
              <img src="assets/irinox/icons/carousel_right.svg"  :alt="$t('common.next')" />
            </template>

            <vueper-slide
                v-for="i in appliance.cycle.cycleTotalPhases"
                :key="i"
                :title="i.toString()"
                :style="'background-color: white'" 
                >
              <template #content>
                <div v-if="i===efCyclePhaseNumber" :class="['phase-header']">{{(i-1).toString().padStart(2, '0')}}. {{$t('ef.phases.'+appliance.cycle.phaseRunning).toUpperCase()}}</div>
                <div v-else :class="['phase-header',{'phase-done':i<efCyclePhaseNumber}]">{{(i-1).toString().padStart(2, '0')}}.  {{$t('library.cycle.phase')}}</div>

                <div v-if="i<efCyclePhaseNumber" :class="['phase','phase-done']">
                  <div> </div>
                  <div class="setpoint p-jc-center">{{$t('library.cycle.previous_phase')}}</div>
                  <div> </div>
                </div>

                <div v-else-if="i==efCyclePhaseNumber" :class="['phase','phase-running']">
                  <div> </div>
                  <div class="setpoint" v-if="efAirSetpointEnabled">
                    <div :class="['p-grid', 'p-ai-center']">
                      <div class="p-col-fixed p-text-center">
                        <span class="icon-air_temp"/>
                      </div>
                      <div class="p-col p-text-right">
                        <span v-if="efCycleRunning">{{$functions.temperature(efAirSetpoint, isCelsius)}}{{unit}}</span> 
                        <span v-else>-{{unit}}</span>  
                      </div>
                    </div>
                  </div>
                  <Divider v-if="efAirSetpointEnabled && (efCoreSetpointEnabled || efDurationSetpointEnabled || efFanSetpointEnabled)" />
                  <div class="setpoint" v-if="efCoreSetpointEnabled">
                    <div :class="['p-grid', 'p-ai-center']">
                      <div class="p-col-fixed p-text-center">
                        <span class="icon-core_temp"/>
                      </div>
                      <div class="p-col p-text-right">
                        <span v-if="efCycleRunning">{{$functions.temperature(efCoreSetpoint,isCelsius)}}{{unit}}</span> 
                        <span v-else>-{{unit}}</span>  
                      </div>
                    </div>
                  </div>
                  <Divider v-if="efCoreSetpointEnabled && (efDurationSetpointEnabled || efFanSetpointEnabled)" />
                  <div class="setpoint" v-if="efDurationSetpointEnabled">
                    <div :class="['p-grid', 'p-ai-center']">
                      <div class="p-col-fixed p-text-center">
                        <span class="icon-time"/>
                      </div>
                      <div class="p-col p-text-right">
                        <span>{{efDuration}}</span> 
                      </div>
                    </div>
                  </div>
                  <Divider v-if="efDurationSetpointEnabled && efFanSetpointEnabled"/>
                  <div class="setpoint" v-if="efFanSetpointEnabled">
                    <div :class="['p-grid', 'p-ai-center']">
                      <div class="p-col-fixed p-text-center">
                        <span class="icon-fan"/>
                      </div>
                      <div class="p-col p-text-right">
                        <span v-if="efCycleRunning">{{efFanLevel}}</span> 
                        <span v-else>-</span> 
                      </div>
                    </div>
                  </div>
                  <div> </div>
                </div>

                <div v-else :class="['phase','phase-todo']">
                  <div> </div>
                  <div class="setpoint p-jc-center">{{$t('library.cycle.next_phase')}}</div>
                  <div> </div>
                </div>

              </template>
            </vueper-slide>
          </vueper-slides>

          <div v-if="!readOnlyMode" :style="{visibility: currentSlide==efCyclePhaseNumber?'visible':'hidden'}">
            <div class="p-grid nested-grid p-jc-center controls">
              <div v-if="efAirSetpointEnabled" class="p-col-fixed">
                <Control v-model="setpoints.temperature" icon="icon-air_temp" :isTemperature="true" :min="limits.cellSetTempMin" :max="limits.cellSetTempMax" @update:modelValue="startProgress" />
              </div>
              <div v-if="efCoreSetpointEnabled" class="p-col-fixed">
                <Control v-model="setpoints.core" icon="icon-core_temp" :isTemperature="true" :min="limits.coreProbeSetTempMin" :max="limits.coreProbeSetTempMax" @update:modelValue="startProgress" />
              </div>
              <div v-if="efDurationSetpointEnabled" class="p-col-fixed">
                <Control v-model="setpoints.time" icon="icon-time" :isTime="true" :min="limits.phaseDurationSetMin" :max="limits.phaseDurationSetMax" @update:modelValue="startProgress"/>
              </div>
              <div v-if="efFanSetpointEnabled" class="p-col-fixed">
                <Control v-model="setpoints.fan" icon="icon-fan" :min="limits.evapFanSetSpeedMin" :max="limits.evapFanSetSpeedMax" @update:modelValue="startProgress"/>
              </div>
            </div>
          </div>

          <div class="cycle-progress-bar p-grid">
            <div v-for="i in appliance.cycle.cycleTotalPhases" :key="'progress-'+i" 
              :class="['p-col','phase-progress-bar',{'phase-progress-bar-done':i<efCyclePhaseNumber}]">
                <span v-if="i==efCyclePhaseNumber" class="phase-progress-bar-running" :style="'width: '+progressBar+'%'"></span>
            </div>

          </div>

        </div>

        <div v-else>

          {{$t('ef.no_cycle_running')}}

        </div>
		</div>
	</div>

  <IrinoxDialogDark :visible="dialog.error" 
    mode="error" 
    :message="$t('details.dialog_error')"
    :life="3000" 
    @update:visible="dialog.error = $event" />

  <IrinoxDialogDark :visible="dialog.stop" mode="confirm" 
    :leftB="$t('library.cycle.stop_dialog_cancel_button')" @click:left-button="() => {dialog.stop = false;}" 
    :rightB="$t('library.cycle.stop_dialog_ok_button')" @click:right-button="stopCycle" 
    :message="$t('library.cycle.stop_dialog')"
    icon="assets/irinox/icons/play_big.svg" />
  <IrinoxDialogDark :visible="dialog.stopSuccess" 
    mode="success" 
    :message="$t('library.cycle.stop_dialog_success')"
    :life="3000" 
    @update:visible="dialog.stopSuccess = $event" />


</template>

<script>
import ApplianceService from '../../../service/ApplianceService';
import EventHubListenerService from '../../../service/EventHubListenerService';
import IrinoxDialogDark from '../../IrinoxDialogDark.vue';
import { VueperSlides, VueperSlide } from 'vueperslides';
import 'vueperslides/dist/vueperslides.css';
// https://antoniandre.github.io/vueper-slides/?ref=madewithvuejs.com
import { mapGetters } from 'vuex';
import Control from '../Control.vue';
import commands from "../../../../public/json/commands_ef.json"
import commands_usa from "../../../../public/json/commands_ef_usa.json"

export default {
    components: {
      IrinoxDialogDark,
      VueperSlides, 
      VueperSlide,
      Control
    },
    data() {
        return {
          serialNumber: this.$route.params.serialNumber,
          commands: commands,
          dialog: {
            blockingError: false,
            stop: false,
            stopSuccess: false
          },
          currentSlide: null,
          setpoints: {
            temperature: 0,
            core: 0,
            time: 0,
            fan: 0,
          },
          progressBar: 100,
          limits: {
            name: null,
            cellSetTempMin: null,
            cellSetTempMax: null,
            coreProbeSetTempMin: null,
            coreProbeSetTempMax: null,
            evapFanSetSpeedMin: null,
            evapFanSetSpeedMax: null,
            phaseDurationSetMin: null,
            phaseDurationSetMax: null
          }
        };
    },
    computed: {
        ...mapGetters({
          personaltoken: 'userdata/personaltoken',
          unit: 'userdata/unit',
          role: 'userdata/role',
          deviceTwin: 'appliances/deviceTwin',
          isCelsius: 'userdata/isCelsius',
        }),
        isExcellence: function() {
          return this.deviceTwin && this.deviceTwin.info && this.deviceTwin.info.package==2;
          // return false;
        },
        readOnlyMode: function() {
          return this.role.includes('INTERNAL') || this.role==='SERVICE_SALES';
        },
        appliance: function() {
            return this.$store.getters['appliances/appliance'](this.serialNumber);
        },
        efCycleRunning: function() {
          return this.appliance.online && this.deviceTwin && this.deviceTwin.status && this.deviceTwin.status.cycleRunning && this.deviceTwin.status.cycleRunning === 1;
        },
        efAirTemp: function() {
          return this.appliance.status && this.appliance.status.TCell!=null ? this.appliance.status.TCell : null;
        },
        efCoreTemp: function() {
          return this.appliance.status && this.appliance.status.TCore!=null ? this.appliance.status.TCore : null;
        },
        efIsCore: function() {
          return this.appliance.cycle && this.appliance.cycle.coreProbeCheck && this.appliance.cycle.coreProbeCheck==3;
        },
        efAirSetpoint: function() {
          return this.appliance.status && this.appliance.status.cellSetTemp!=null ? this.appliance.status.cellSetTemp : null;
        },
        efCoreSetpoint: function() {
          return this.appliance.status && this.appliance.status.coreProbeSetTemp!=null ? this.appliance.status.coreProbeSetTemp : null;
        },
        efAirSetpointEnabled: function() {
          return this.limits.cellSetTempMin!=null && this.limits.cellSetTempMax!=null;
        },
        efCoreSetpointEnabled: function() {
          return this.limits.coreProbeSetTempMin!=null && this.limits.coreProbeSetTempMax!=null && this.efIsCore;
        },
        efDurationSetpointEnabled: function() {
          return this.limits.phaseDurationSetMin!=null && this.limits.phaseDurationSetMax!=null && !this.efIsCore;
        },
        efFanSetpointEnabled: function() {
          return this.limits.evapFanSetSpeedMin!=null && this.limits.evapFanSetSpeedMax!=null && this.isExcellence;
        },
        efFanLevel: function() {
          return this.appliance.status && this.appliance.status.evapFanSetSpeed!=null ? this.appliance.status.evapFanSetSpeed : null;
        },
        efDuration: function() {
          try {
            //phaseDurationSet is in seconds
            let time = this.efCycleRunning && this.appliance.status ? this.appliance.status.phaseDurationSet / 60 : null;
            //time in minutes
            if(time) {
              var hours = Math.floor(time / 60);
              time = time - hours * 60;
              var minutes = Math.floor(time);
              return (hours<10?"0"+hours:hours)+"h:"+(minutes<10?"0"+minutes:minutes)+"m";
            }
          } catch(err) {
            return "N/A";
          }
          return "--h:--m";
        },
        efDurationSetpoint: function() {
          return this.efCycleRunning && this.appliance.status ? this.appliance.status.phaseDurationSet / 60 : 0;
        },
        efTimeLeft: function() {
          return this.efCycleRunning && this.appliance.cycle && this.appliance.cycle.cycleTimeLeft ? this.appliance.cycle.cycleTimeLeft / 60 : 0;
        },
        // efPercentage: function() {
        //   if(this.efDurationSetpoint>0 && this.efTimeLeft>0) {
        //     return (this.efDurationSetpoint-(this.efTimeLeft/60)) * 100 / this.efDurationSetpoint;
        //   } else {
        //     return 0;
        //   }
        // },
        efCyclePhaseNumber: function() {
          return this.appliance.cycle.cyclePhaseNumber;
        },
        // limits: function() {
        //   if(this.efCycleRunning) {
        //     try {
        //       let f = this.commands.functions[String(this.appliance.cycle.functionRunning)];
        //       let p = f.phases[String(this.appliance.cycle.phaseRunning)];
        //       if(p) {
        //         let lim = this.$functions.clone(p);
        //         if(lim.cellSetTempMin) {
        //           lim.cellSetTempMin*=10;
        //         }
        //         if(lim.cellSetTempMax) {
        //           lim.cellSetTempMax*=10;
        //         }
        //         if(lim.coreProbeSetTempMin) {
        //           lim.coreProbeSetTempMin = Math.max(lim.coreProbeSetTempMin*10, this.efAirSetpoint!=null ? this.efAirSetpoint : lim.coreProbeSetTempMin*10);
        //           // lim.coreProbeSetTempMin*=10;
        //         }
        //         if(lim.coreProbeSetTempMax) {
        //           lim.coreProbeSetTempMax*=10;
        //         }
        //         return lim;
        //       }
        //     } catch(err) {
        //       console.warn("Error parsing commands " + err);
        //     }
        //   }
        //   return {
        //       name: null,
        //       cellSetTempMin: null,
        //       cellSetTempMax: null,
        //       coreProbeSetTempMin: null,
        //       coreProbeSetTempMax: null,
        //       evapFanSetSpeedMin: null,
        //       evapFanSetSpeedMax: null,
        //       phaseDurationSetMin: null,
        //       phaseDurationSetMax: null
        //     };
        // }
    },
    watch: {
      'efAirSetpoint': 'updateLimits',
      'efCycleRunning': 'updateLimits',
      'appliance.cycle.functionRunning': 'updateLimits',
      'appliance.cycle.phaseRunning': 'updateLimits',
    },
    created() {
      // setInterval(function() {
      //   // if(this.efContinuousCycleRunning) {
      //     if(this.progressBar>=100) {
      //       this.progressBar = 0;
      //     }
      //     this.progressBar+=0.25;
      //   // } else {
      //   //   this.progressBar = this.efPercentage;
      //   // }
      // }.bind(this),10)
      this.applianceService = new ApplianceService();
      this.eventHubListenerService = new EventHubListenerService();
    },
    mounted() {
      // if(!this.$config.mock) {
        this.reloadAppliance();
      // }
      this.reloadDeviceTwin();
    },
    methods: {
      reloadAppliance() {
        this.applianceService.getAppliance(this.personaltoken, this.serialNumber)
          .then((data) => {
            if(data.code=="200") {
              let appliance = data.body;
              this.$store.commit('appliances/applianceDetails', appliance);
              if(appliance.online) {
                this.eventHubListenerService.postRunLive(this.personaltoken, this.serialNumber)
                  .then((data) => {
                    if(data.code=="200") {
                      console.log("RUN LIVE success")
                    } else {
                      console.error("RUN LIVE ERROR "+JSON.stringify(data));
                    }
                  })
                  .catch(error => {
                    console.error("RUN LIVE ERROR "+error);
                  });
              }
            } else {
              console.error(JSON.stringify(data));
              this.dialog.blockingError = true;
              setTimeout(function() {
                this.$router.push({ name: 'dashboard' });
              }.bind(this),3000);
            }
          })
          .catch(error => {
            console.error("ERROR "+error);
            this.dialog.blockingError = true;
            setTimeout(function() {
              this.$router.push({ name: 'dashboard' });
            }.bind(this),3000);
          });
      },
      reloadDeviceTwin() {
        this.eventHubListenerService.getDeviceTwin(this.personaltoken, this.serialNumber, this.appliance.type)
          .then((data) => {
            if(data.code=="200") {
              let dt = data.body;
              dt.serialNumber = this.serialNumber;
              this.$store.commit('appliances/deviceTwin', dt);
              if(dt.status?.setLimit === 2) {
                this.commands = commands_usa;
              } else {
                this.commands = commands;
              }
              this.updateLimits();
            } else {
              console.error("ERROR "+JSON.stringify(data));
              this.dialog.blockingError = true;
            }
          })
          .catch(error => {
            console.error("ERROR "+error);
            this.dialog.blockingError = true;
          });
      },
      updateLimits() {
        if(this.efCycleRunning) {
          try {
            let f = this.commands.functions[String(this.appliance.cycle.functionRunning)];
            let p = f.phases[String(this.appliance.cycle.phaseRunning)];
            if(p) {
              let lim = this.$functions.clone(p);
              if(lim.cellSetTempMin) {
                lim.cellSetTempMin*=10;
              }
              if(lim.cellSetTempMax) {
                lim.cellSetTempMax*=10;
              }
              if(lim.coreProbeSetTempMin) {
                lim.coreProbeSetTempMin = Math.max(lim.coreProbeSetTempMin*10, this.efAirSetpoint!=null ? this.efAirSetpoint : lim.coreProbeSetTempMin*10);
                // lim.coreProbeSetTempMin*=10;
              }
              if(lim.coreProbeSetTempMax) {
                lim.coreProbeSetTempMax*=10;
              }
              this.limits = lim;
              return;
            }
          } catch(err) {
            console.warn("Error parsing commands " + err);
          }
        }
        this.limits = {
            name: null,
            cellSetTempMin: null,
            cellSetTempMax: null,
            coreProbeSetTempMin: null,
            coreProbeSetTempMax: null,
            evapFanSetSpeedMin: null,
            evapFanSetSpeedMax: null,
            phaseDurationSetMin: null,
            phaseDurationSetMax: null
          };

      },
      carouselReady() {
        this.$refs.phases.goToSlide(this.efCyclePhaseNumber - 1);
      },
      changeSlide(eventName, params) {
        console.log("changeSlide",JSON.stringify(params));
        this.currentSlide = params.currentSlide.index + 1;
        this.setpoints = {
            temperature: this.efAirSetpoint,
            core: this.efCoreSetpoint,
            time: this.efDurationSetpoint,
            fan: this.efFanLevel,
          }

        if(this.limits.cellSetTempMin != null && this.setpoints.temperature < this.limits.cellSetTempMin) {
          this.setpoints.temperature = this.limits.cellSetTempMin;
        }
        if(this.limits.cellSetTempMax != null && this.setpoints.temperature > this.limits.cellSetTempMax) {
          this.setpoints.temperature = this.limits.cellSetTempMax;
        }

        if(this.limits.coreProbeSetTempMin != null && this.setpoints.core < this.limits.coreProbeSetTempMin) {
          this.setpoints.core = this.limits.coreProbeSetTempMin;
        }
        if(this.limits.coreProbeSetTempMax != null && this.setpoints.core > this.limits.coreProbeSetTempMax) {
          this.setpoints.core = this.limits.coreProbeSetTempMax;
        }

        if(this.limits.phaseDurationSetMin != null && this.setpoints.time < this.limits.phaseDurationSetMin) {
          this.setpoints.time = this.limits.phaseDurationSetMin;
        }
        if(this.limits.phaseDurationSetMax != null && this.setpoints.time > this.limits.phaseDurationSetMax) {
          this.setpoints.time = this.limits.phaseDurationSetMax;
        }

        if(this.limits.evapFanSetSpeedMin != null && this.setpoints.fan < this.limits.evapFanSetSpeedMin) {
          this.setpoints.fan = this.limits.evapFanSetSpeedMin;
        }
        if(this.limits.evapFanSetSpeedMax != null && this.setpoints.fan > this.limits.evapFanSetSpeedMax) {
          this.setpoints.fan = this.limits.evapFanSetSpeedMax;
        }

      },
      startProgress() {
        this.endProgress();
        this.waitingForSaving = setTimeout(() => {
          console.log(JSON.stringify(this.setpoints));
          this.saveParameter();
        },2000);
      },
      endProgress() {
        clearTimeout(this.waitingForSaving);
        this.waitingForSaving = null;
      },
      saveParameter() {

        let data = {};

        if(this.limits.cellSetTempMin!=null && this.limits.cellSetTempMax!=null) {
          data.cellSetTemp = this.setpoints.temperature;
        }

        if(this.limits.coreProbeSetTempMin!=null && this.limits.coreProbeSetTempMax!=null && this.efIsCore) {
          data.coreProbeSetTemp = this.setpoints.core;
        }

        if(this.setpoints.fan!=this.efFanLevel 
            && this.limits.evapFanSetSpeedMin!=null && this.limits.evapFanSetSpeedMax!=null && this.isExcellence) {
          data.evapFanSetSpeed = this.setpoints.fan;
        }

        if(this.setpoints.time!=this.efDurationSetpoint 
            && this.limits.phaseDurationSetMin!=null && this.limits.phaseDurationSetMax!=null && !this.efIsCore) {
          data.phaseDurationSet = this.setpoints.time * 60;
        }

        this.eventHubListenerService.postSetSetpoint(this.personaltoken, this.serialNumber, data)
          .then((response) => {
            if(response.code=="200") {
              console.log("Setpoints updated: "+JSON.stringify(data));
              let appl = this.$functions.clone(this.appliance);
              if(data.cellSetTemp!=null) {
                appl.status.cellSetTemp = data.cellSetTemp;
              }
              if(data.coreProbeSetTemp!=null) {
                appl.status.coreProbeSetTemp = data.coreProbeSetTemp;
              }
              if(data.evapFanSetSpeed!=null) {
                appl.status.evapFanSetSpeed = data.evapFanSetSpeed;
              }
              if(data.time!=null) {
                appl.status.phaseDurationSet = data.phaseDurationSet;
              }
              this.$store.commit('appliances/applianceDetails', appl);
            } else {
              console.error("EXCEPTION "+JSON.stringify(response));
              this.dialog.error = true;
            }
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.dialog.error = true;
          });
      },
      stopCycle() {
        // let recipeId = this.appliance.cycle.runningCycleId;
        // if(typeof recipeId === "number") {
        //   recipeId = "IRINOX_" + (recipeId).toString().padStart(8, '0');
        // }
        let stopCommand = {
          // id: recipeId,
          operationSet: 0
        };
        this.dialog.stop = false;
        this.eventHubListenerService.postStartStop(this.personaltoken, this.serialNumber, stopCommand)
          .then((data) => {
            if(data.code=="200") {
              this.dialog.stopSuccess = true;
              setTimeout(function() {
                this.$router.push({ name: 'appliance-details', params: { serialNumber: this.serialNumber } });
              }.bind(this),3000);
            } else {
              console.error("ERROR "+JSON.stringify(data));
              this.dialog.error = true;
            }
          })
          .catch(error => {
            console.error("ERROR "+error);
            this.dialog.error = true;
          });
      },
    }
}
</script>

<style scoped>

.layout-content {
  overflow-x: hidden;
}

</style>

<style>

.cycle-progress-bar {
  margin: 1rem 2rem 0;
  border: 1px solid #002445;
  padding: 1px;
  height: 15px;
}
.phase-progress-bar {
  background: #FFFFFF;
  padding: 0;
  border-left: 1px solid #002445;
}
.phase-progress-bar-done {
  background: #002445;
  border-left: 1px solid #FFFFFF;
}
.phase-progress-bar-running {
  background: #002445;
  height: 100%;
  display: block;
  border-left: 1px solid #FFFFFF;
}

.phase .p-col-12 {
  padding: 0;
}

.ex--center-mode {
  width: 400px;
  max-width: 80%;
  margin: auto;
}

.vueperslides__parallax-wrapper {
  overflow: visible;
}

.vueperslides__track {
  overflow: visible;
}

.vueperslides__arrow {
  color: rgba(169, 169, 169, 0.5);
  stroke-width: 2;
}

.vueperslide {
  /* padding: 25px; */
  -webkit-transform: scale(.75);
  transform: scale(.75);
}
.vueperslide .phase .p-divider {
  margin: 0;
}
.vueperslide .phase .setpoint {
  height: 50px;
  align-items: center;
  display: flex;
  width: 100%;
  font-size: 38px;
  font-weight: 600;
}
.vueperslide .phase .setpoint .p-grid {
  margin: 0;
  width: 100%;
}
.vueperslide .phase .setpoint .p-grid .p-col,
.vueperslide .phase .setpoint .p-grid .p-col-fixed {
  padding: 0 1rem;
}
.vueperslide .phase .setpoint .p-grid .p-col-fixed {
  display: flex;
}
.vueperslide .phase .setpoint [class^=icon-], 
.vueperslide .phase .setpoint [class*=" icon-"] {
  font-size: 45px;
}
.vueperslide .phase {
  width: 100%;
  height: calc(100% - 70px);
  background: #FFFFFF;
  box-sizing: border-box;
  border-radius: 0px 0px 10px 10px;
  overflow: hidden;
  border: 1px solid #002445;
  border-top: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  /* padding: 0.5rem 1rem; */
  padding: 0rem 1rem;
}
.vueperslide .phase.phase-running {
  border: 5px solid #002445;
}
.vueperslide .phase.phase-done {
  border: 1px solid #B4B4B4;
}
.vueperslide .phase-header {
  height: 70px;
  border-radius: 10px 10px 0px 0px;
  background: #002445;
  border: 1px solid #002445;
  font-size: 34px;
  font-weight: 600;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  text-align: center;
}
/* .vueperslide .phase-header.phase-done {
  background: #C2410C;
  border: 1px solid #C2410C;
} */

.vueperslide.vueperslide--active {
  -webkit-transform: scale(1); 
  transform: scale(1);
}

.vueperslides__track-inner .vueperslide.vueperslide--active ~ .vueperslide {
  position: relative;
  left: 50px;
}
.vueperslides__track-inner .vueperslide {
  position: relative;
  left: -50px;
}
.vueperslides__track-inner .vueperslide.vueperslide--active {
  position: relative;
  left: 0px;
}

.vueperslides--rtl .vueperslides__arrows--outside .vueperslides__arrow--next, .vueperslides__arrows--outside .vueperslides__arrow--prev {
  left: -4em;
}
.vueperslides--rtl .vueperslides__arrows--outside .vueperslides__arrow--prev, .vueperslides__arrows--outside .vueperslides__arrow--next {
  right: -4em;
}

.fade-left {
  position: absolute;
  left: 82;
  background: linear-gradient(90deg, rgba(255,255,255,0.8) 0%, rgba(255,255,255,0) 100%);
  height: 400px;
  width: calc(50% - 320px);
  z-index: 10;
}
.fade-right {
  position: absolute;
  right: 0;
  background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.8) 100%);
  height: 400px;
  width: calc(50% - 320px);
  z-index: 10;
}

.vueperslides__arrow svg {
  stroke-width: 2px;
}
.vueperslides__arrow svg:hover {
  stroke-width: 2px;
}

.cycle-controls .controls > div {
  width: 330px;
  padding: .5rem;
}
.cycle-controls .control > div {
  text-align: center;
}

.cycle-controls .p-divider.p-divider-horizontal:before {
  border-top-width: 2px;
}

</style>